module.exports = __webpack_public_path__ + "static/assets/978a7854350d260c1d463f8d679ebea5.png";